const OverrideField = (props) => {
  return(
    (props.data.override && props.data.override[props.source]) ?
      <span>({props.data.override[props.source]})</span>
      :
      <span>{props.value}</span>
  );
};

export default OverrideField;